document.addEventListener("DOMContentLoaded", () => {
    /* =====================================================
       ScrollHint
    ===================================================== */
    new ScrollHint('.js-scrollable', {
        scrollHintIconAppendClass: 'scroll-hint-icon-white',
        applyToParents: true,
        i18n: {
            scrollable: 'スクロールできます'
        }
    });


    /* =====================================================
       タブ切替
    ===================================================== */

    document.querySelectorAll(".menulist_wrap .tab").forEach(tab => {
        tab.addEventListener("click", function () {
            document.querySelectorAll(".typeTab_area .tab").forEach(t => {
                t.classList.remove("active");
            });
            this.classList.add("active");
            const id = this.id;
            [".tab-content_lifeinfo"].forEach(selector => {
                document.querySelectorAll(selector).forEach(el => {
                    el.classList.remove("active");
                });
            });
            document.querySelectorAll("." + id).forEach(el => {
                el.classList.add("active");
            });
        });
    });

    const targets = document.querySelectorAll('.js-line-animate');

    const splitLines = (target) => {
        // 元のHTMLを保持
        const original = target.dataset.original || target.innerHTML;
        target.dataset.original = original;
        target.innerHTML = original;


        const nodes = Array.from(target.childNodes);
        const lines = [];
        let currentLine = [];

        nodes.forEach((node) => {
            if (node.nodeName === 'BR') {
                // ★ 表示されている br だけを改行扱い
                const style = window.getComputedStyle(node);
                if (style.display !== 'none') {
                    lines.push(currentLine);
                    currentLine = [];
                }
            } else {
                currentLine.push(node);
            }
        });
        lines.push(currentLine);

        target.innerHTML = '';

        lines.forEach((lineNodes) => {
            if (!lineNodes.length) return;

            const line = document.createElement('span');
            line.className = 'line';

            const inner = document.createElement('span');
            lineNodes.forEach((n) => inner.appendChild(n));

            line.appendChild(inner);
            target.appendChild(line);
        });
    };

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const lines = entry.target.querySelectorAll('.line > span');
                lines.forEach((line, i) => {
                    line.style.transitionDelay = `${i * 0.15}s`;
                });

                entry.target.classList.add('is-show');
                observer.unobserve(entry.target);
            });
        },
        { threshold: 0.2 }
    );

    const init = () => {
        targets.forEach((target) => {
            target.classList.remove('is-show');
            splitLines(target);
            observer.observe(target);
        });
    };

    init();


});